import { useRef, useState } from "react";
import {
  DownloadIcon,
  HeartIcon,
  NoteIcon,
  NotificationIcon,
  PlayPauseIcon,
  ShareIcon,
  WebLogo,
} from "utils/Icons";
import repeatImgW from "assets/images/icons/repeatW.png";
import v1S from "assets/sounds/v1.mp3";
import MusicSlider from "utils/MusicSlider";
import { Fade } from "react-awesome-reveal";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
// import { auth } from "config/firebase";
import QueryChecker from "utils/queryChecker";

const UserHome = () => {
  const { data: user } = useSelector((store) => store.auth);
  // console.log(user?.firstSession?.meditation?.induction?.media?.audio?.url)
  //  modal state
  const [modalOpen, setModalOpen] = useState(true);
  // play / pause
  const [isPlaying, setIsPlaying] = useState(false);
  // all duration
  const [duration, setDuration] = useState(0);
  // current audio duration
  const [currentTime, setCurrentTime] = useState(0);
  // audio ref
  const audioRef = useRef(null);
  // track
  const [percentage, setPercentage] = useState(0);
  // replay/repeat
  const [replay, setReplayMode] = useState(false);

  // handle play pause music
  const togglePlayPause = () => {
    setIsPlaying(!isPlaying);
    const audio = audioRef.current;
    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
  };

  // Get Duration
  const getCurrDuration = (e) => {
    const audio = audioRef.current;
    const percent = (
      (e.currentTarget.currentTime / e.currentTarget.duration) *
      100
    ).toFixed(2);
    const time = e.currentTarget.currentTime;
    if (+percent) {
      setPercentage(+percent);
    } else {
      setPercentage(0);
    }
    setCurrentTime(time.toFixed(2));
    if (Number(percent) >= 100.0) {
      if (replay) {
        setIsPlaying(true);
        setPercentage(0);
        audio.play();
      } else {
        setIsPlaying(false);
        audio.pause();
      }
    }
  };

  // on Change Track
  const onChange = (e) => {
    const audio = audioRef.current;
    audio.currentTime = Math.floor((audio.duration / 100) * e.target.value);
    setPercentage(e.target.value);
    setIsPlaying(true);
    audio.play();
  };

  // secondsTo H ms
  function secondsToHms(seconds) {
    if (!seconds) return "0:00";

    let duration = seconds;
    let hours = duration / 3600;
    duration = duration % 3600;

    let min = parseInt(duration / 60);
    duration = duration % 60;

    let sec = parseInt(duration);

    if (sec < 10) {
      sec = `0${sec}`;
    }
    if (min < 10) {
      min = `0${min}`;
    }

    if (parseInt(hours, 10) > 0) {
      return `${parseInt(hours, 10)}h ${min}m ${sec}s`;
    } else if (min === 0) {
      return `0:${sec}`;
    } else {
      return `${min}:${sec}`;
    }
  }

  // handle Replay/Repeat
  const handleReplay = () => {
    setReplayMode(!replay);
  };

  const withQuery = QueryChecker(["promo","email","sId"]);

  // redirect user have not subscribed mamaZen
  if (!user.subscribed && !user.adminSubscribed) {
    return <Navigate to={"/myAccount/purchase" + withQuery} replace />;
  }
  return (
    <div className="music_screen text_center d_flex flex_col">
      {/* <div className="cs_container"> 
       <div className="d_flex w_100 align_items_center justify_content_between">
        <div></div>
        <div style={{ margin: "10px 0" }}>
          <Slide className="w_100" direction="left" triggerOnce>
            <button
              onClick={() => auth.signOut()}
              className="text_white hover_scale cs_btn text_decoration_none"
            >
              Logout
            </button>
          </Slide>
        </div>
      </div> 
      </div> */}
      {/* logo */}
      <div className="music_web_logo">
        <WebLogo />
      </div>
      {/*  */}
      <div className="mt_auto text_white">
        {/*  */}
        <div className="player_wrapper d_flex align_items_center justify_content_between">
          <span className="start_time">{secondsToHms(currentTime)}</span>
          <div className="player_slider_wrapper w_100 d_flex align_items_center justify_content_between">
            <img
              style={{ opacity: !replay ? ".7" : "1" }}
              onClick={handleReplay}
              src={repeatImgW}
              alt=""
            />

            <div className="player_slider_controller w_100">
              <audio
                ref={audioRef}
                onTimeUpdate={getCurrDuration}
                onLoadedData={(e) => {
                  setDuration(e.currentTarget.duration.toFixed(2));
                }}
                src={"https://media.mamazen.com/audio/webappsession.mp3"}
              ></audio>
              <div className="player_progress_wrapper">
                <MusicSlider
                  steps={"0.01"}
                  percentage={percentage}
                  onChange={onChange}
                />
              </div>
            </div>
          </div>
          <span className="end_time"> {secondsToHms(duration)}</span>
        </div>
        <div className="music_title">
          <p>
            {user?.firstName} {user?.firstSession?.title?.substring(2)}
          </p>
          {/* <p>Overcome Anxiety & Overwhelm</p> */}
        </div>
        {/*  */}
        <div className="music_player_btns  d_flex align_items_center justify_content_center">
          <a
            className="cursor_pointer user_select_none music_all_control_btns"
            href="/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <DownloadIcon />
          </a>
          <a
            className="cursor_pointer user_select_none music_all_control_btns"
            href="/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <NotificationIcon />
          </a>
          <PlayPauseIcon
            onClick={togglePlayPause}
            className="cursor_pointer user_select_none music_all_control_btns playPauseSvg"
            role="button"
            play={isPlaying ? "playing" : "paused"}
          />
          <a
            className="cursor_pointer user_select_none music_all_control_btns"
            href="/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <HeartIcon />
          </a>
          <a
            className="cursor_pointer user_select_none music_all_control_btns"
            href="/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <ShareIcon />
          </a>
        </div>
      </div>
      {/* modal */}
      {modalOpen ? (
        <>
        <div className="modal_backdrop"></div>
        <div className="payment_select_modal cs_modal">
          <div className="purchase_sc_top">
            <div className="top_shape d_flex flex_col justify_content_center align_items_center">
              <Fade direction="down" triggerOnce delay={50} duration={1000}>
                <div className="pr_logo">
                  <NoteIcon />
                </div>
              </Fade>
              <Fade direction="up" triggerOnce delay={50} duration={1000}>
                <h3 className="text_white" style={{ margin: "8px auto" }}>
                  IMPORTANT NOTE
                </h3>
              </Fade>
            </div>
          </div>
          <div className="text_center cs_modal_body text_white">
            <Fade triggerOnce delay={300} duration={1200}>
              <p>
                Your membership has been activated! To get started, you must download MamaZen by clicking below. You must select {" "}
                <a
                  href="https://links.mamazen.com/kodb/3omtdl89"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text_primary"
                >
                  {" "}
                  "Already have an account. Log In"{" "}
                </a>{" "}
                on the very first page of the app. Be sure to select EMAIL then use the same email and password you just used.
              </p>
            </Fade>
            <br />
            <Fade triggerOnce delay={700} duration={1500}>
              <a
                href="https://links.mamazen.com/kodb/3omtdl89"
                target="_blank"
                rel="noopener noreferrer"
                className="cs_btn w_100"
              >
                got it
              </a>
            </Fade>
          </div>
        </div>
        </>
      ) : null}
    </div>
  );
};

export default UserHome;
